import { MatSnackBar } from "@angular/material/snack-bar";
import { StringTool } from "src/app/tools/mapping/string.tool";
import { environment } from "src/environments/environment";

export class BaseComponent {
    public ALL = 666; // For combo list non domain date only for display

    get IsMEL() {
        return environment.isMel;
    }

    constructor() {}

    getReferenceLimsColumnLabel() {
        return this.IsMEL ? "Réf MyEasyLab" : "Réf Eurofins";
    }
    
    minimizeStringToMax50Chars(label: string) {
        return StringTool.makeFantasyString(label);
    }

    openFileOnTab(x: any) {

        const url = window.URL.createObjectURL(x.body);
        const a = document.createElement('a');

        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(x.headers.get('Content-Disposition'));
        if (matches != null && matches[1]) {
            a.download = matches[1].replace(/['"]/g, '');

        }
        a.target = '_blank';
        a.href = url;

        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox

        a.click();
        a.remove();
    }
}